import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import InlineGroup from 'components/Common/InlineGroup'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Root = styled.div`
  display: flex;
  align-items: center;
  padding: ${rem(12)};
  border-radius: ${props => props.theme.borderRadius.large};
  border: 1px solid ${props => props.theme.palette.messaging.warning.main};
  background: ${props => props.theme.palette.messaging.warning.light};

  > * + * {
    margin-left: ${rem(12)};
  }
`

interface Props {
  message: string;
  className?: string;
}

function WarningMessage(props: Props) {
  const { message, className } = props

  return (
    <Root className={className}>
      <InlineGroup vertical="center" horizontal="center">
        <LineInfoCircleIcon size={20} />
      </InlineGroup>
      <BodyText variant="medium">{message}</BodyText>
    </Root>
  )
}

export default WarningMessage
